<template>
  <svg
    v-if="Math.floor(value) === 0"
    width="28"
    height="16"
    viewBox="0 0 28 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <rect x="0.785034" width="8" height="5" fill="currentColor" />
    <rect x="0.785034" y="6" width="8" height="5" fill="currentColor" />
    <rect x="9.78503" width="8" height="5" fill="currentColor" />
    <rect x="9.78503" y="6" width="8" height="5" fill="currentColor" />
    <rect x="18.785" width="8" height="5" fill="currentColor" />
    <rect x="18.785" y="6" width="8" height="5" fill="currentColor" />
  </svg>

  <svg
    v-else-if="Math.floor(value) === 33"
    width="29"
    height="17"
    viewBox="0 0 29 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <rect x="1" width="8" height="5" fill="currentColor" />
    <rect x="3" y="6" width="8" height="5" fill="currentColor" />
    <rect x="10" width="8" height="5" fill="currentColor" />
    <rect x="12" y="6" width="8" height="5" fill="currentColor" />
    <rect x="19" width="8" height="5" fill="currentColor" />
    <rect x="21" y="6" width="8" height="5" fill="currentColor" />
  </svg>

  <svg
    v-else-if="Math.floor(value) === 50"
    width="35"
    height="22"
    viewBox="0 0 35 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <rect x="4.28003" y="3" width="8" height="5" fill="currentColor" />
    <rect x="8.42505" y="9" width="8" height="5" fill="currentColor" />
    <rect x="13.28" y="3" width="8" height="5" fill="currentColor" />
    <rect x="17.425" y="9" width="8" height="5" fill="currentColor" />
    <rect x="22.28" y="3" width="8" height="5" fill="currentColor" />
    <rect x="26.425" y="9" width="8" height="5" fill="currentColor" />
  </svg>

  <svg
    v-else-if="Math.floor(value) === 66"
    width="34"
    height="22"
    viewBox="0 0 34 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <rect x="1.85498" y="3" width="8" height="5" fill="currentColor" />
    <rect x="7.56995" y="9" width="8" height="5" fill="currentColor" />
    <rect x="10.855" y="3" width="8" height="5" fill="currentColor" />
    <rect x="16.5699" y="9" width="8" height="5" fill="currentColor" />
    <rect x="19.855" y="3" width="8" height="5" fill="currentColor" />
    <rect x="25.5699" y="9" width="8" height="5" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: "GridAlignmentIcon",
  props: {
    value: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: "white",
    },
  },
};
</script>
